<div class="auth-page">
  <div class="auth-card">
    <!-- Header -->
    <div class="auth-head">
      <nubo-logo variant="lockup" size="lg" class="auth-logo"></nubo-logo>
      <ng-container *ngIf="!emailSent">
        <h1>Welcome back</h1>
        <p class="auth-sub">Sign in to your Nubo account.</p>
      </ng-container>
      <ng-container *ngIf="emailSent">
        <h1>Check your email</h1>
        <p class="auth-sub">
          We sent a 6-digit code to<br />
          <strong>{{ form.value.email }}</strong>.
        </p>
      </ng-container>
    </div>

    <!-- Error -->
    <div class="auth-error" *ngIf="errorMessage" role="alert">
      <mat-icon>error_outline</mat-icon>
      <span>{{ errorMessage }}</span>
    </div>

    <!-- Step 1: email -->
    <form *ngIf="!emailSent" [formGroup]="form" (ngSubmit)="sendOtp()" class="auth-form" novalidate>
      <mat-form-field appearance="outline" class="w-full">
        <mat-label>Email address</mat-label>
        <input matInput type="email" formControlName="email" autocomplete="email"
               placeholder="you@company.com" />
        <mat-error *ngIf="form.get('email')?.hasError('required')">Email is required.</mat-error>
        <mat-error *ngIf="form.get('email')?.hasError('email')">Enter a valid email address.</mat-error>
      </mat-form-field>

      <button type="submit" class="auth-btn" [disabled]="sending">
        <span class="spinner" *ngIf="sending"></span>
        <ng-container *ngIf="!sending"><span>Continue</span><mat-icon>arrow_forward</mat-icon></ng-container>
        <ng-container *ngIf="sending">Sending code…</ng-container>
      </button>
    </form>

    <!-- Step 2: OTP -->
    <div *ngIf="emailSent" class="auth-form">
      <div class="otp-group" role="group" aria-label="Enter the 6-digit verification code">
        <input *ngFor="let d of otpDigits; let i = index; trackBy: trackByIndex" #otpBox
               class="otp-box"
               type="text"
               inputmode="numeric"
               maxlength="1"
               [attr.aria-label]="'Digit ' + (i + 1)"
               [attr.autocomplete]="i === 0 ? 'one-time-code' : 'off'"
               [class.filled]="!!otpDigits[i]"
               [value]="otpDigits[i]"
               (input)="onOtpDigit($event, i)"
               (keydown)="onOtpKeydown($event, i)"
               (paste)="onOtpPaste($event)" />
      </div>

      <button type="button" class="auth-btn" (click)="verifyCode()"
              [disabled]="verifying || code.length !== 6">
        <span class="spinner" *ngIf="verifying"></span>
        <ng-container *ngIf="!verifying"><mat-icon>lock_open</mat-icon><span>Verify &amp; sign in</span></ng-container>
        <ng-container *ngIf="verifying">Verifying…</ng-container>
      </button>

      <div class="auth-resend">
        <span *ngIf="!canResend" class="muted">Resend code in {{ resendCountdown }}s</span>
        <button *ngIf="canResend" type="button" class="link-btn" (click)="resendOtp()" [disabled]="sending">
          Resend code
        </button>
      </div>

      <button type="button" class="link-btn block" (click)="changeEmail()">
        <mat-icon>arrow_back</mat-icon> Use a different email
      </button>
    </div>

    <!-- Footer -->
    <div class="auth-footer" *ngIf="!emailSent">
      Don’t have an account? <a routerLink="/registration">Create one</a>
    </div>
  </div>
</div>
